/**
 * Utility to check if user is still authenticated by validating the auth cookie
 * Used for cross-tab logout detection
 */

const AUTH_COOKIE_NAMES = [
  'cmAuthenticationUserToken',
  'cmAuthenticationCrewToken',
  'cmAuthenticationCrewId',
  'cmV3AuthenticationUserToken',
];

/**
 * Check if any authentication cookie exists
 * @returns {boolean} True if any auth cookie exists, false otherwise
 */
export const hasAuthCookie = () => {
  if (typeof document === 'undefined') return false;

  const cookies = document.cookie;
  return AUTH_COOKIE_NAMES.some((cookieName) => cookies.includes(cookieName));
};

/**
 * Check if user has lost authentication (cookie was cleared)
 * @param {Object} authState - Current authentication state (from state.authentication)
 * @returns {boolean} True if user was authenticated but cookie is now gone
 */
export const hasLostAuthentication = (authState) => {
  if (!authState) return true;

  // The state structure has: { authentication: {...}, isLoadingCurrent: boolean }
  const auth = authState?.authentication;
  if (!auth) return false;

  const hasUserAuth = auth?.userAuthentication?.userId;
  const hasCrewAuth = auth?.crewAuthentication?.crewId;
  const isAuthenticated = hasUserAuth || hasCrewAuth;

  // If we think we're authenticated but the cookie is gone, auth was lost
  return isAuthenticated && !hasAuthCookie();
};
